import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Eyebrow, PrimaryButton, Section, SecondaryButton } from "../ui/primitives";
import { colors, company } from "../ui/tokens";

// Closing call to action shown above the footer on most pages.
export default function CtaBand() {
  const { t } = useTranslation("Common");
  return (
    <Section tone="navy" py={{ xs: 8, md: 11 }}>
      <Grid container spacing={{ xs: 4, md: 8 }} alignItems="flex-end">
        <Grid item xs={12} md={7}>
          <Eyebrow dark>{t("cta.eyebrow")}</Eyebrow>
          <Typography variant="h2" component="h2" sx={{ color: colors.onDark }}>
            {t("cta.title")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={5}>
          <Typography sx={{ color: colors.onDarkMuted, fontSize: "1.05rem", mb: 3.5 }}>{t("cta.body")}</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            <PrimaryButton to="/contact" dark>{t("cta.primary")}</PrimaryButton>
            <SecondaryButton to={`mailto:${company.email}`} dark>{t("cta.secondary")}</SecondaryButton>
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
}
